module.exports = __webpack_public_path__ + "static/media/icon_expired_items.9b92772b.svg";